import { render } from "./GeneralStatisticView.vue?vue&type=template&id=c3f2a298&scoped=true"
import script from "./GeneralStatisticView.vue?vue&type=script&lang=js"
export * from "./GeneralStatisticView.vue?vue&type=script&lang=js"

import "./GeneralStatisticView.vue?vue&type=style&index=0&id=c3f2a298&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f2a298"]])

export default __exports__